'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/react-dom/index.js
// module id = 29
// module chunks = 0